import React from 'react';

const FittingInfo = ({ designDetails }) => {
	return (
		<div className="style-single mb-2">
			<div className="label-box fitting-box">
				<ul>
					<li className="regular-12 weight-500 gray_dark_02 mb-1">
						<span className="name">
							Fitting Info :
							<span className="semibold-12 ml-1">{designDetails?.referenceNumber}</span>
						</span>
					</li>
					<li className="gray_dark_01 regular-12 weight-600 mb-1"></li>
					<li className="gray_dark_01 regular-12 weight-600 mb-1">
						{designDetails?.blockDetailsResponse?.blockTitle}
					</li>
				</ul>
				<p className="regular-12 text-uppercase gray_dark_02">
					{[
						designDetails?.blockDetailsResponse?.fittingTypeTag?.text,
						designDetails?.blockDetailsResponse?.riseTag?.text,
						designDetails?.blockDetailsResponse?.lengthTag?.text,
						designDetails?.blockDetailsResponse?.inspirationBrand?.name,
						designDetails?.blockDetailsResponse?.sizeStandardTag?.text,
						designDetails?.blockDetailsResponse?.avatarTag?.text
					]
						.filter(Boolean)
						.join(', ')}
				</p>

				{designDetails?.blockDetailsResponse?.isBlock && (
					<span className="block-status status yellow-1 radius">BLOCK</span>
				)}
			</div>
		</div>
	);
};

export default FittingInfo;
